/**
 * Newsletter Popup
 * Shows when user scrolls 50% down the page
 * Remembers dismissal for 7 days
 */

(function() {
  const STORAGE_KEY = 'riotbites_newsletter_popup_dismissed';
  const DISMISS_DAYS = 2;
  const SCROLL_THRESHOLD = 0.5; // 50% of page

  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.newsletter-popup__close');
  const form = popup.querySelector('.newsletter-popup__form');

  // Check if popup was recently dismissed
  function isRecentlyDismissed() {
    const dismissedAt = localStorage.getItem(STORAGE_KEY);
    if (!dismissedAt) return false;

    const dismissDate = new Date(parseInt(dismissedAt, 10));
    const now = new Date();
    const daysDiff = (now - dismissDate) / (1000 * 60 * 60 * 24);

    return daysDiff < DISMISS_DAYS;
  }

  // Save dismissal timestamp
  function saveDismissal() {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
  }

  // Show popup
  function showPopup() {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
  }

  // Hide popup
  function hidePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    saveDismissal();
  }

  // Handle scroll to show popup
  function handleScroll() {
    const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPosition = window.scrollY;
    const scrollPercentage = scrollPosition / scrollHeight;

    if (scrollPercentage >= SCROLL_THRESHOLD) {
      showPopup();
      // Remove scroll listener after showing
      window.removeEventListener('scroll', handleScroll);
    }
  }

  // Initialize
  function init() {
    // Don't show if recently dismissed
    if (isRecentlyDismissed()) return;

    // Close button handler
    if (closeBtn) {
      closeBtn.addEventListener('click', hidePopup);
    }

    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        hidePopup();
      }
    });

    // Form submission - dismiss popup on success
    if (form) {
      form.addEventListener('submit', function() {
        saveDismissal();
      });
    }

    // Listen for scroll
    window.addEventListener('scroll', handleScroll);

    // Check initial scroll position (in case page loaded scrolled)
    handleScroll();
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
